import React, { PropTypes } from 'react';

import SquadListContainer from './SquadListContainer.jsx';
import VirtualEventListContainer from './VirtualEventListContainer.jsx';
import OrderReview from 'shared/OrderReview.jsx';
import JumbotronLink from 'shared/JumbotronLink.jsx';
import ClearCartConfirmationContainer from '../shared/ClearCartConfirmationContainer.jsx';
import DisplayIf from 'shared/DisplayIf.jsx';
import PaymentFormContainer from './EmbededForm/PaymentFormContainer.jsx';

const Checkout = ({
  disablePayInFull,
  tournamentId,
  tournamentName,
  tournamentStripeKey,
  processing,
  cart,
  total,
  amount,
  onClearCartClick,
  onPay,
  onCreatePaymentClientSecret,
  onContinueShoppingClick,
  termsUrl,
  agreedToTerms,
  onAgreeToTermsClick,
  enabledWebHooks,
  onWebHooksClick,
  environment,
  validationMessages,
  showPaymentDialog
}) => (
  <div>
    <OrderReview
      total={total}
    >
      <SquadListContainer />
      <VirtualEventListContainer />
      {!cart || (!cart.squads.length && !cart.virtualEvents.length)
        ? <JumbotronLink
          message={'Your shopping cart is empty.'}
          linkPath={`registration/schedule/${tournamentId}`}
          linkText={'Return to Calendar'}
        />
        : null
      }
    </OrderReview>

    <ClearCartConfirmationContainer />

    <DisplayIf condition={!!termsUrl}
      className="custom-checkbox-container"
      style={{ float: "right", paddingBottom: 15 }}>
      <input type="checkbox"
        id="agreeToTerms"
        checked={agreedToTerms}
        onChange={event => onAgreeToTermsClick(event.target.checked)} />
      <label htmlFor="agreeToTerms">
        Check here to agree to the &nbsp;
        <a target="_blank"
          rel="noopener noreferrer"
          href={termsUrl}>Terms &amp; Conditions</a>.
      </label>

      <DisplayIf condition={amount > 0 && (environment != 'PROD' && environment != 'PRODUCTION')}
        className="custom-checkbox-container"
        style={{ float: "left", paddingBottom: 15 }}>
        <input type="checkbox"
          id="webHooks"
          checked={enabledWebHooks}
          onChange={event => onWebHooksClick(event.target.checked)} />
        <label htmlFor="webHooks">
          Click here to process payments in real time.
        </label>
      </DisplayIf>
    </DisplayIf>

    <DisplayIf condition={Array.isArray(validationMessages) && validationMessages.length > 0}>
      <div className="col-xs-12">
        <div className="alert alert-danger text-center">
          <div>
            {validationMessages ? validationMessages.map((message, index) => (
              <div key={index}>
                {`${message}`}
              </div>
            )) : null}
          </div>
        </div>
      </div>
    </DisplayIf>

    <DisplayIf condition={!termsUrl && amount > 0 && (environment != 'PROD' && environment != 'PRODUCTION')}
      className="custom-checkbox-container"
      style={{ float: "right", paddingBottom: 15 }}>
      <input type="checkbox"
        id="webHooks"
        checked={enabledWebHooks}
        onChange={event => onWebHooksClick(event.target.checked)} />
      <label htmlFor="webHooks">
        Click here to process payments in real time.
      </label>
    </DisplayIf>

    <PaymentFormContainer onCreatePaymentClientSecret={onCreatePaymentClientSecret}
      tournamentStripeKey={tournamentStripeKey} cart={cart} total={total} processing={processing}
      tournamentName={tournamentName} validationMessages={validationMessages}
      showPaymentDialog={showPaymentDialog} />


    <div className="text-right"
      style={{ float: "right", width: "100%" }}>
      <span>
        <button
          type="button"
          className="btn btn-link"
          disabled={processing}
          onClick={onClearCartClick}
        >{'Clear My Cart'}</button>
        {' '}
        <button
          type="button"
          className="btn btn-link"
          disabled={processing}
          onClick={onContinueShoppingClick}
        >{'Return to Calendar'}</button>
        {' '}
        <div className="display inline">
          <button
            type="button"
            className="btn btn-primary btn-lg"
            disabled={(termsUrl && !agreedToTerms) || disablePayInFull || processing || validationMessages}
            onClick={() => onPay({
              amount,
              cart
            })}
          ><i className="fa fa-credit-card" /> {processing ? `Processing...` : amount > 0 ? `Pay Full Amount` : `Complete Transaction`}</button>
        </div>
      </span>
    </div>
    <DisplayIf condition={processing}
      className="spinnerBackdrop" />
  </div>
);

Checkout.propTypes = {
  disablePayInFull: PropTypes.bool,
  tournamentId: PropTypes.string,
  processing: PropTypes.bool,
  cart: PropTypes.object,
  total: PropTypes.number,
  amount: PropTypes.string,
  onClearCartClick: PropTypes.func,
  onPay: PropTypes.func,
  onContinueShoppingClick: PropTypes.func,
  termsUrl: PropTypes.string,
  agreedToTerms: PropTypes.bool,
  onAgreeToTermsClick: PropTypes.func,
  enabledWebHooks: PropTypes.bool,
  onWebHooksClick: PropTypes.func,
  environment: PropTypes.string,
  validationMessages: PropTypes.arrayOf(PropTypes.string),
  showPaymentDialog: PropTypes.bool,
  onCancelPaymentEmbeddedForm: PropTypes.func,
};

export default Checkout;



// WEBPACK FOOTER //
// ./src/features/registration/checkout/Checkout.jsx